export const removeMarkdownTags = (value: string | undefined): string =>
  value?.replaceAll(/[*>~]/g, '') || ''
